type StableAnalyticsTriggerOptions = {
  delayMs: number;
  onStable: () => void;
};

export type StableAnalyticsTrigger = {
  update: (enabled: boolean, stableKey: string | number) => void;
  dispose: () => void;
};

export function createStableAnalyticsTrigger({
  delayMs,
  onStable,
}: StableAnalyticsTriggerOptions): StableAnalyticsTrigger {
  let timerId: ReturnType<typeof setTimeout> | undefined;
  let lastStableKey: string | number | undefined;
  let lastEnabled = false;

  const clearTimer = () => {
    if (timerId !== undefined) {
      clearTimeout(timerId);
      timerId = undefined;
    }
  };

  return {
    update(enabled, stableKey) {
      if (!enabled) {
        clearTimer();
        lastEnabled = false;
        lastStableKey = stableKey;
        return;
      }

      if (lastEnabled && lastStableKey === stableKey) {
        return;
      }

      clearTimer();
      lastEnabled = true;
      lastStableKey = stableKey;
      timerId = setTimeout(() => {
        timerId = undefined;
        onStable();
      }, delayMs);
    },
    dispose() {
      clearTimer();
      lastEnabled = false;
      lastStableKey = undefined;
    },
  };
}
